module.exports = __webpack_public_path__ + "static/blog-recriando-raizes-eed90bb322c988f76346dcf10494c259.jpg";